/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FC, useCallback, useRef } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import { useAuth } from '~/hooks/Auth';
import getValidationErros from '~/utils/getValidationsErrors';

import { Container, AnimationContainer, Background } from './styles';
import Input from '~/components/Input';

import wiserr from '~/assets/defaults/wiserr.png';
import logoText from '~/assets/logos/wiserr-text.png';
import loginBackground from '~/assets/banners/login-banner.png';

interface SignInFormData {
  email: string;
  password: string;
}

const SignIn: FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { signIn } = useAuth();

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .email('Email Address must be a valid email')
            .required('Email Address is a required'),
          password: Yup.string().required('Password is a required'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await signIn({
          email: data.email,
          password: data.password,
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire(
            'Opss...',
            'There was an error signing in, check credentials',
            'error'
          );
        }
      }
    },
    [signIn]
  );

  return (
    <Container className="d-flex align-items-center">
      <div className="container-fluid h-100">
        <div className="row justify-content-center justify-content-lg-start align-items-center h-100">
          <Background
            src={loginBackground}
            className="d-none d-lg-flex col-lg-6 text-center d-flex align-items-center justify-content-center"
          >
            <img src={logoText} width={184} height={39} alt="Wiserr" />
          </Background>

          <div className="position-absolute w-auto px-0 position d-none d-md-block">
            <img src={wiserr} alt="Wiserr" />
          </div>

          <AnimationContainer className="col-11 col-sm-9 col-lg-6 px-0 px-sm-3 my-5 my-lg-0">
            <div className="align-items-center mb-xl-3 shadow">
              <div className="p-xxl-5 p-lg-4 p-sm-5 p-4 login">
                <h1 className="h2 h1-lg display-xl-4 text-sm-left fw-bold mb-3">
                  Welcome back!
                </h1>
                <p className="h5 fw-normal mb-5">
                  Enter your information below to login
                </p>

                <Form ref={formRef} onSubmit={handleSubmit}>
                  <label htmlFor="email" className="d-block mb-1 mt-3 small">
                    Email:
                  </label>
                  <Input id="email" name="email" className="bg-transparent" />
                  <label htmlFor="password" className="d-block mb-1 mt-4 small">
                    Password:
                  </label>
                  <Input
                    id="password"
                    type="password"
                    name="password"
                    className="bg-transparent btn-show-custom"
                  />
                  {/* <Link
                  to={`${process.env.PUBLIC_URL}/forgot-password`}
                  className="small mb-xl-3 mb-xxl-5 w-100 mt-2 mt-md-4 text-right"
                >
                  {language.sign_in.a_1}
                </Link> */}
                  <button type="submit" className="button-login mt-5 w-100">
                    <span className="h5 text-white fw-bold d-block px-5 py-3 mb-0">
                      Login
                    </span>
                  </button>
                </Form>
              </div>
            </div>
          </AnimationContainer>
        </div>
      </div>
    </Container>
  );
};

export default SignIn;
